import { createSelector } from 'reselect';

export const getStoreAccesor = state => state.store.store;

export const storesSelector = createSelector(getStoreAccesor, store => store);
